module.exports = __webpack_public_path__ + "img/Tablet - 15.04933d2c.png";